<div *ngIf="showName === true || showName == null" [class.mat-subheading-1]="SmallDisplay" class="margin-bottom-none">
    {{ greeting }}, {{ username | titleCase }}!<span *ngIf="user?.CurrentRole"> ({{ user?.CurrentRole | roleText }} Access)</span>
</div>
